<script>
    import { onMount } from "svelte";

    import Select from "svelte-select/Select.svelte";

    import CardLayout from "../../../../Components/Common/CardLayout.svelte";

    import {
        loggedInDoctorDetail,
        prePopulateAccountOptions,
    } from "../../../../stores";

    import { cacheAccountPrePopulateSearchOptions } from "../../../../Utils/utilCache.svelte";

    export let patientSectionRef, procedureDetailsRef, insuranceDetailsRef;

    let selectedDoctor = {};

    onMount(() => {
        _initSelectedDoctor();
    });

    const handleSelectDoctor = async () => {
        $loggedInDoctorDetail = { ...selectedDoctor };
        delete $loggedInDoctorDetail.key;

        // reload doctor providers
        await insuranceDetailsRef.loadSelectedDoctor();

        insuranceDetailsRef.clearSelectedDoctorProvider(
            !$loggedInDoctorDetail.providers?.length,
        );

        $loggedInDoctorDetail.providers?.length &&
            insuranceDetailsRef._setDefaultDoctorProvider();

        // reload surgeon
        procedureDetailsRef.reloadSurgeon();

        // reload hospital
        procedureDetailsRef.reloadHospital();

        // match patient
        patientSectionRef.handleMatchPatient(true);
    };

    const loadDoctors = async (filterText) => {
        await cacheAccountPrePopulateSearchOptions();

        if (!filterText)
            return $prePopulateAccountOptions.length
                ? $prePopulateAccountOptions
                : [];

        return $prePopulateAccountOptions.length
            ? $prePopulateAccountOptions.filter(({ value }) =>
                  value.toLowerCase().includes(filterText.toLowerCase()),
              )
            : [];
    };

    // HELPER FUNCTIONS
    const _initSelectedDoctor = async () => {
        selectedDoctor = { ...$loggedInDoctorDetail };

        await cacheAccountPrePopulateSearchOptions();

        if (
            $prePopulateAccountOptions.some(
                (acc) => acc.id == selectedDoctor.id,
            )
        )
            selectedDoctor = $prePopulateAccountOptions.find(
                (acc) => acc.id == selectedDoctor.id,
            );
    };
</script>

<CardLayout title="Doctor" enableCollapse={false}>
    <div class="flex flex-1 p-4 w-full">
        <div class="grid grid-cols-3 gap-y-4 w-full items-center">
            <div class="flex flex-1 col-span-2 gap-x-2 items-center">
                <Select
                    bind:value={selectedDoctor}
                    on:select={handleSelectDoctor}
                    loadOptions={loadDoctors}
                    clearable={false}
                    class="flex flex-1 max-h-[35px] rounded-full"
                    itemId="key"
                    label="value"
                    noOptionsMessage="No doctors found"
                    placeholder="Select a doctor"
                />
            </div>
        </div>
    </div>
</CardLayout>
